import type { EditorRemixLifecyclePhase } from '@atlassian/malleable-ui-components/types';

export type RemixThinkingLifecycleProjection = {
	isComplete: boolean;
	isThinking: boolean;
};

export const projectEditorRemixLifecycleToThinking = ({
	animationFinished,
	phase,
}: {
	animationFinished: boolean;
	phase: EditorRemixLifecyclePhase;
}): RemixThinkingLifecycleProjection => {
	switch (phase) {
		case 'inactive':
		case 'error':
		case 'aborted':
			return { isThinking: false, isComplete: false };

		case 'thinking':
			return { isThinking: true, isComplete: false };

		case 'ready':
			return animationFinished
				? { isThinking: false, isComplete: true }
				: { isThinking: true, isComplete: true };

		case 'previewing':
			return { isThinking: false, isComplete: true };

		case 'inserting':
			return { isThinking: false, isComplete: true };

		default: {
			const exhaustive: never = phase;
			return exhaustive;
		}
	}
};
